import React, { Component, Fragment } from "react";
import TopNavigation from "../../Components/Common/TopNavigation";
import TopBannerSlider from "../../Components/Home/TopBannerSlider";
import PopularCategories from "../../Components/Home/PopularCategories";
import TrendingNowProducts from "../../Components/Home/TrendingNowProducts";
import NewArrival from "../../Components/Home/NewArrival";
import SpecialCollection from "../../Components/Home/SpecialCollection";
import Footer from "../../Components/Common/Footer";
import "../../Assets/CSS/Home.css";
import Service from "../../Components/Home/Services";
import Motamot from "../../Components/Home/Motamot";
import GiftBoxProducts from "../../Components/Home/GiftBoxProducts";
import MangoProducts from "../../Components/Home/MangoProducts";
class HomePage extends Component {

  componentDidMount() {
    window.scroll(0, 0);
  }


  render() {
    return (
      <Fragment>
        <TopNavigation />
        <TopBannerSlider />

        <PopularCategories />
        <TrendingNowProducts />
        <GiftBoxProducts />
        <MangoProducts />
        <NewArrival />
        <Service />
        <SpecialCollection />
        <Motamot />
        <Footer />
      </Fragment>
    );
  }
}

export default HomePage;
